<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30" id="offerSkuList">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th class="wd-lg-300">{{$t('other.任务类型')}}</th>
            <th class="wd-lg-200">{{$t('other.操作人')}}</th>
            <th class="wd-lg-200">{{$t('other.状态')}}</th>
            <th class="wd-lg-200">{{$t('other.创建时间')}}</th>
            <th class="wd-lg-200">{{$t('other.开始时间')}}</th>
            <th class="wd-lg-200">{{$t('other.完成时间')}}</th>
            <th class="wd-lg-200">{{$t('other.操作')}}</th>
          </tr>
        </thead>
        <tbody>
        	<!---->
          <tr v-for="(item,index) in items" :key="item.id">
            <td class="valign-middle tx-white">
            	{{item.taskName}}
            </td>
            <td class="valign-middle tx-white tx-ellipsis1">
            	{{item.operator}}
            </td>
            <td class="valign-middle">
            	<span :class="item.status | statusClass">{{$t(statusArr[item.status])}}</span>
            	<a href="javascript:;">
            		<i v-if="item.status == 4" data-toggle="tooltip-primary" data-placement="bottom" :data-original-title="$t('other.超过一个月为已过期')" class="col-form-label ion-ios-help-outline tx-16 tx-danger mg-l-5"></i>
            		<i v-if="item.status == 9 && item.failReason" data-toggle="tooltip-primary" data-placement="bottom" :data-original-title="item.failReason" class="col-form-label ion-ios-help-outline tx-16 tx-danger mg-l-5"></i>
            	</a>
            	<div>
            		<span v-if="item.failCnt>0 || item.successCnt>0">
	            		(<span>{{$t('other.成功个数：')}}<span class="tx-success"> {{item.successCnt?item.successCnt:'0'}} </span></span>,
	            		<span>{{$t('other.失败个数：')}}<span class="tx-danger"> {{item.failCnt?item.failCnt:'0'}} </span></span>)
	            	</span>
            	</div>
            </td>
            <td class="valign-middle tx-white">
            	{{item.timeCreated?item.timeCreated:'---'}}
            </td>
            <td class="valign-middle tx-white">
            	{{item.timeStarted?item.timeStarted:'---'}}
            </td>
            <td class="valign-middle tx-white">
            	{{item.timeFinished?item.timeFinished:'---'}}
            </td>
            <td class="valign-middle tx-white">
              <a v-if="item.status == 3 && item.file" href="javascript:;" class="tx-info" @click="download(item.file)">{{$t('other.下载结果文件')}}</a>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="7">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t('other.没有符合条件的下载任务')}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items","type_arr"],
  data() {
    return {
    	statusArr: arrDict.downloadStatus,
    };
  },
  watch: {
  },
  computed:{
  },
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
			template: '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
		});
  },
  filters: {
    statusClass(val) {
      if (!val) return;
      let className = "";
      switch (val) {
        case "1":
          className = "tx-white";
          break;
        case "2":
          className = "tx-warning";
          break;
        case "3":
          className = "tx-success";
          break;
        case "9":
          className = "tx-danger";
          break;
      }
      return className;
    },
  },
  methods: {
		download(url){
			if ($("#ifilePro").length == 0) {
        $("body").append(
          '<iframe id="ifilePro" style="display:none"></iframe>'
        );
      }
			document.getElementById("ifilePro").src = url;
		},
  }
};
</script>
<style scoped="scoped">
	.table td.valign-middle, .table th.valign-middle{
		padding-bottom: 10px;
		padding-top: 10px;
	}
</style>

